module.exports = __webpack_public_path__ + "img/diesel-locomotive-mask-05.bef84486.png";